import i18next from '@/i18n';

// Когда язык меняется (переключатель в HeaderContent вызывает i18next.changeLanguage,
// либо react-i18next-backend догружает файл перевода асинхронно), нужно заставить
// Angular пересчитать дайджест-цикл, чтобы фильтр `translate` (см.
// app/core/filters/translate.js) подхватил новый язык без действий пользователя.
angular.module('shbdeployer.app').run([
  '$rootScope',
  function ($rootScope) {
    i18next.on('languageChanged', function () {
      $rootScope.$applyAsync();
    });
  },
]);
